import React, { createContext, useContext, useMemo, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { appNav } from "../../routes/appNavigation";
import "./FinanceLayout.css";

const tabClass = ({ isActive }: { isActive: boolean }) =>
  `finance-layout__tab${isActive ? " finance-layout__tab--active" : ""}`;

type FinanceChrome = {
  search: string;
  setSearch: (value: string) => void;
  editingKpis: boolean;
  setEditingKpis: (value: boolean) => void;
};

const FinanceChromeContext = createContext<FinanceChrome | null>(null);

export function useFinanceChrome(): FinanceChrome {
  const ctx = useContext(FinanceChromeContext);
  if (!ctx) {
    return {
      search: "",
      setSearch: () => undefined,
      editingKpis: false,
      setEditingKpis: () => undefined,
    };
  }
  return ctx;
}

export const FinanceLayout: React.FC = () => {
  const { pathname } = useLocation();
  const isPortfolio = pathname === "/finance" || pathname === "/finance/";
  const [search, setSearch] = useState("");
  const [editingKpis, setEditingKpis] = useState(false);
  const chrome = useMemo(
    () => ({ search, setSearch, editingKpis, setEditingKpis }),
    [search, editingKpis],
  );

  return (
    <FinanceChromeContext.Provider value={chrome}>
      <div className="finance-layout finance-layout--fit">
        <header className="finance-layout__chrome">
          <div className="finance-layout__brand">
            <h1 className="app-shell-page-title">Finance</h1>
            <nav className="finance-layout__tabs" aria-label="Finance sections">
              <NavLink to={appNav.finance()} end className={tabClass}>
                Portfolio
              </NavLink>
              <NavLink to={appNav.financeAnalytics()} className={tabClass}>
                Overview
              </NavLink>
              <NavLink to={appNav.financeEvents()} className={tabClass}>
                Event
              </NavLink>
              <NavLink to={appNav.financeInvoices()} className={tabClass}>
                Invoice
              </NavLink>
            </nav>
          </div>
          {isPortfolio ? (
            <div className="finance-layout__tools">
              <label className="finance-layout__search">
                <span className="visually-hidden">Search finance</span>
                <input
                  className="eventos-input"
                  placeholder="Search…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </label>
              <button
                type="button"
                className={`eventos-nav-btn finance-layout__edit${editingKpis ? " is-active" : ""}`}
                onClick={() => setEditingKpis(!editingKpis)}
              >
                {editingKpis ? "Done" : "Edit"}
              </button>
            </div>
          ) : null}
        </header>
        <div className="finance-layout__body">
          <Outlet />
        </div>
      </div>
    </FinanceChromeContext.Provider>
  );
};
